import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class CaptchaService {
    private resolvedSource: Subject<string> = new Subject();
    private resolutionRequiredSource: Subject<string> = new Subject();

    public resolved$ = this.resolvedSource.asObservable();
    public resolutionRequired$ = this.resolutionRequiredSource.asObservable();

    public resolved(token) {
        this.resolvedSource.next(token);
    }
    public requireResolution() {
        this.resolutionRequiredSource.next();
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src727013012/src/src/app/payment/services/captcha.service.ts